export default {
  text: 'Verifiëren met {{provider}}',
  text_generic: 'Verifiëren met uw betalingsprovider',
  error: 'We konden het {{provider}}-formulier niet openen. Probeer het opnieuw.',
  error_generic: 'We konden het formulier van de betalingsprovider niet openen. Probeer het opnieuw.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
